import React, { useEffect, useMemo, useState } from 'react';

function resolveProfilePhotoUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  const s = String(pathOrUrl).trim();
  if (!s) return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  const base = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000').replace(/\/$/, '');
  return `${base}${s.startsWith('/') ? s : `/${s}`}`;
}

function pickProfilePicture(record) {
  if (!record) return '';
  const direct = [
    record.profile_picture,
    record.profilePicture,
    record.avatar,
    record.employeeProfilePicture,
    record.employeeAvatar,
  ];
  const nested = record.employee
    ? [
        record.employee.profile_picture,
        record.employee.profilePicture,
        record.employee.avatar,
      ]
    : [];
  const first = [...direct, ...nested].find(Boolean);
  return first ? resolveProfilePhotoUrl(first) : '';
}

function computeInitials(name, email) {
  const display = (name || '').trim();
  if (display) {
    const parts = display.split(/\s+/).filter(Boolean);
    const first = parts[0]?.charAt(0) || '';
    const second = parts[1]?.charAt(0) || '';
    const value = (first + second).toUpperCase();
    if (value) return value;
  }
  const fallback = (email || '').trim().charAt(0).toUpperCase();
  return fallback || '?';
}

export default function EmployeeAvatar({
  record,
  name,
  email,
  sizeClass = 'w-12 h-12',
  textClass = 'text-sm',
  className = '',
}) {
  const [failed, setFailed] = useState(false);
  const src = useMemo(() => pickProfilePicture(record), [record]);

  useEffect(() => {
    setFailed(false);
  }, [src, email]);

  const initials = computeInitials(name, email);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        className={`${sizeClass} rounded-full object-cover bg-gray-200 ${className}`.trim()}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-gradient-to-br from-blue-100 to-teal-100 text-blue-800 flex items-center justify-center font-semibold ${textClass} ${className}`.trim()}
      aria-hidden
    >
      {initials}
    </div>
  );
}
